export const COMMON_COLLAPSE_CHANGE = 'COMMON_COLLAPSE_CHANGE';
export const COMMON_SET_LOADING = 'COMMON_SET_LOADING';
export const COMMON_LOGOUT_SUCCESS = 'COMMON_LOGOUT_SUCCESS';
export const COMMON_CHANGE_ROLE_LIST = 'COMMON_CHANGE_ROLE_LIST';
export const COMMON_CHANGE_PASSWORD_VISIBLE = 'COMMON_CHANGE_PASSWORD_VISIBLE';
export const COMMON_CHANGE_PASSWORD_BEGIN = 'COMMON_CHANGE_PASSWORD_BEGIN';
export const COMMON_CHANGE_PASSWORD_SUCCESS = 'COMMON_CHANGE_PASSWORD_SUCCESS';
export const COMMON_CHANGE_PASSWORD_FAILURE = 'COMMON_CHANGE_PASSWORD_FAILURE';
export const COMMON_CHANGE_PASSWORD_DISMISS_ERROR = 'COMMON_CHANGE_PASSWORD_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/common/redux/constants.js